import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import Axios from 'axios'
import store from './store'
import VCalendar from 'v-calendar'
import '@/assets/css/tailwind.css';
import './registerServiceWorker'
import 'fontawesome-free/css/all.css'
import 'fontawesome-free/js/all.js'

Vue.config.productionTip = false

export const HTTP = Axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
})

Vue.prototype.$http = HTTP

export const axiosConfig = HTTP.interceptors.request.use((config) => {
  config.headers = {
    'Content-Type': 'application/json',
    Authorization: 'JWT ' + store.getters.auth.token
  }
  return config
})

Vue.use(VCalendar)

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
